import { AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppMultipleSelectInput from "@toothfairy/shared-ui/AppMultipleSelectInput";
import AppPlaceholderView from "@toothfairy/shared-ui/AppPlaceholderView";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import { Platform, View } from "react-native";
import { isLargeScreen } from "../Screens/MainViewContainer";
import ToothFairyModal from "./ToothFairyComponents/ToothFairyModal";

const DocumentSearchModal = ({
  isModalOpen,
  setIsModalOpen,
  searchText,
  setSearchText,
  handleDocumentSelection,
  promiseOptions,
  colourStyles,
}) => {
  const { currentTheme } = AppTheme.useTheme();

  return (
    <ToothFairyModal
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      modalStyle={{
        height: "80%",
        width: Platform.OS === "web" && isLargeScreen() ? "70%" : "95%",
        maxWidth: 800,
        marginHorizontal: "auto",
        marginTop: "auto",
        marginBottom: "auto",
        borderRadius: 20,
      }}
      modalInnerContentStyle={{
        paddingHorizontal: 20,
        paddingVertical: 20,
      }}
      modalTitle="Find Documents"
    >
      <View
        style={{
          flex: 1,
          minHeight: 400,
        }}
      >
        <AppText
          wrapperStyle={{
            marginBottom: 15,
          }}
          color={currentTheme?.theme?.primary}
          style={{
            fontWeight: "bold",
            fontSize: currentTheme?.theme?.base_font_size,
          }}
        >
          Search for documents in your knowledge hub
        </AppText>

        <AppMultipleSelectInput
          accessibilityLabel="docs_search_modal"
          onSelectionChange={(v) => {
            handleDocumentSelection(v);
            setIsModalOpen(false);
          }}
          onInputChange={(v) => {
            setSearchText(v);
          }}
          autoFocus={true}
          inputValue={searchText}
          defaultInputValue={searchText}
          selectedItems={[]}
          labelOption={"title"}
          placeholder="Type to search documents..."
          isAsync={true}
          promiseOptions={promiseOptions}
          uniqueKey="chunk_id"
          showDropDowns={true}
          readOnlyHeadings={true}
          styles={{
            ...colourStyles,
            control: (styles) => ({
              ...colourStyles.control(styles),
              minWidth: "100%",
              maxWidth: "100%",
              marginBottom: 20,
            }),
            menu: (styles) => ({
              ...colourStyles.menu(styles),
              zIndex: 1000,
            }),
          }}
          wrapperStyle={{
            flex: 1,
            zIndex: 1,
          }}
        />
        {(searchText?.trim() == "" || !searchText) && (
          <AppPlaceholderView
            accessibilityLabel="doc-placeholder"
            wrapperStyle={{
              width: 300,
              height: 200,
              marginVertical: "auto",
              marginHorizontal: "auto",
            }}
            size={30}
            icon={AppAssets.icons.orbit}
            mainCaption={"Start typing to see matching documents"}
            subCaption={"Click on a result to navigate to that document"}
          />
        )}
      </View>
    </ToothFairyModal>
  );
};

export default DocumentSearchModal;
